import {Component, Input} from '@angular/core';
import {Application} from '@services/model/application';
import {ProductStatus} from '@services/model/product';
import {isNone, Option} from 'fp-ts/lib/Option';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-steps-panel',
  templateUrl: './steps-panel.component.html',
  styleUrls: ['./steps-panel.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class StepsPanelComponent {
  @Input() application: Option<Application>;
  get currentProductStatusNumber(): number {
    if (!this.application) {
      return -1;
    }

    if (isNone(this.application)) {
      return 1;
    }
    switch (this.application.value.productStatus) {
      case ProductStatus.requested:
        return 2;
      case ProductStatus.denied:
        return 3;
      case ProductStatus.approved:
        return 4;
      case ProductStatus.invited:
        return 5;
      case ProductStatus.notInvited:
        return 6;
      default:
        return 0;
    }
  }
}
